import { BehaviorSubject, Subject } from 'rxjs';

export class BaseActionService {
    protected _isLoadingActionSubject = new BehaviorSubject<boolean>(false);
    public isLoadingAction$ = this._isLoadingActionSubject.asObservable();

    protected _errorActionSubject = new Subject<string>();
    public actionError$ = this._errorActionSubject.asObservable();

    protected _successMessageSubject = new Subject<string>();
    public successMessage$ = this._successMessageSubject;
}
